var imagesLoaded = require('imagesloaded');
if (window) {
  window.imagesLoaded = imagesLoaded;
}
require('angular');
require('./angular-images-loaded');
module.exports = 'hj.imagesLoaded';



//////////////////
// WEBPACK FOOTER
// ./node_modules/angular-images-loaded/index.js
// module id = 65
// module chunks = 0